<template>
  <question-group headline="Blast">
    <blast-response :model="blast.blastPrompt" :maxchars="blast.assignment.shortFormLength" v-model="blast.blastPrompt.response" :respondable="blast.isOpen" />
    <review-display :blast="blast" />
  </question-group>
</template>

<script>

  import sidebar from "./sidebar.js"
  import ReviewDisplay from "../ReviewDisplay"

  export default {
    name: 'blast',
    mixins: [sidebar],
    components: { ReviewDisplay }
  }

</script>

<style lang="scss" scoped>

  @import "~globals";

</style>



// WEBPACK FOOTER //
// src/components/BlastStudent/sidebar/blast.vue